import type {
    UserScheduleSettingsData,
    UserScheduleSettingsSaveParams,
    UserScheduleSettingsUpdateParams,
    UserScheduleSettingsListQuery,
    UserScheduleSettingsListResponse,
    UserScheduleSettingsResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/user-schedule-settings';

export class UserScheduleSettingsApi {
    public static async list(params?: UserScheduleSettingsListQuery): Promise<UserScheduleSettingsData[]> {
        const res = await axios.get<UserScheduleSettingsListResponse>(BASE_URL, { params });

        return res.data.userScheduleSettings;
    }

    public static async get(userId: string): Promise<UserScheduleSettingsData | undefined> {
        const res = await axios.get<UserScheduleSettingsResponse>(`${BASE_URL}/${userId}`);

        return res.data.userScheduleSettings;
    }

    public static async save(userId: string, userScheduleSettings: UserScheduleSettingsUpdateParams): Promise<void> {
        const params: UserScheduleSettingsSaveParams = { userId, ...userScheduleSettings };

        await axios.put(BASE_URL, { userScheduleSettings: params });
    }
}
